export const formatPathName = value => value.slice().reverse().join(' / ');